// src/routes/ProtectedRouteLogout.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { isAccessTokenValid } from "../../api/auth";

function ProtectedRouteLogout({ children }) {
  const isAuthenticated = isAccessTokenValid();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRouteLogout;